<button
  class="single-sign-on__identity-provider"
  data-track
  ftrButton
  [fullWidth]="true"
  color="secondary"
  (click)="startSSOLogin(identityProvider.Google)"
>
  <svg ftrIcon="Google" [iconSize]="24" class="align-top"></svg>
  Continue with Google
</button>
<button
  class="single-sign-on__identity-provider"
  data-track
  ftrButton
  [fullWidth]="true"
  color="secondary"
  (click)="startSSOLogin(identityProvider.Microsoft)"
>
  <svg ftrIcon="Microsoft" [iconSize]="24" class="align-top"></svg>
  Continue with Microsoft
</button>
@if (showMockLogin) {
  <button
    class="single-sign-on__identity-provider"
    data-track
    ftrButton
    [fullWidth]="true"
    color="secondary"
    id="mockLoginButton"
    (click)="startSSOLogin(identityProvider.Mock)"
  >
    Continue with Mock
  </button>
}
